import { useNavigate } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <p className={styles.code}>404</p>
                <h2 className={styles.title}>페이지를 찾을 수 없습니다</h2>
                <p className={styles.desc}>
                    요청하신 페이지가 존재하지 않거나 이동되었습니다.
                </p>
                <div className={styles.buttons}>
                    <button className={styles.btnPrimary} onClick={() => navigate('/')}>
                        홈으로
                    </button>
                    <button className={styles.btnOutline} onClick={() => navigate(-1)}>
                        이전 페이지
                    </button>
                </div>
            </div>
        </div>
    );
}

export default NotFoundPage;